import layers from './layers';
import modals from './modals';

export default {
    layers,
    modals
}